import classNames from 'clsx';
import React from 'react';

import BannerImage from '../../../assets/path_identity.svg';
import type { StepKey } from '../../../types';
import BannerName from '../BannerName/BannerName';

import styles from './Banner.scss';

interface BannerProps {
  stepKey: StepKey;
  bannerClassName: string;
}

const Banner: React.FC<BannerProps> = ({ stepKey, bannerClassName }) => (
  <div className={styles.banner}>
    <BannerName stepKey={stepKey} />
    <BannerImage className={classNames(styles.bannerBackground, bannerClassName)} />
  </div>
);

export default Banner;
